import {Injectable} from '@angular/core';
import {HttpResponse} from '@angular/common/http';


@Injectable({ providedIn: 'root' })
export class DownloadService {

  private saveAs(url, filename) {
    // crea elemento ancora nascosto e forza il click
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  private getFileNameFromResponseContentDisposition(res) {
    const contentDisposition = res.headers.get('content-disposition') || '';
    const matches = /filename=([^;]+)/ig.exec(contentDisposition);
    const fileName = (matches[1] || 'untitled').trim();
    return fileName;
  }

  downloadFile(response: HttpResponse<Blob>, filename: string) {
    const blob = new Blob([response.body], {type: response.body.type});
    const url = URL.createObjectURL(blob);
    // IE & Edge fix for downloading blob files, gives option to save or open the file when the link is opened.
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    }

    const calculatedFilename = filename.replace(/(\s)/g, '_') ||
      this.getFileNameFromResponseContentDisposition(response);
    this.saveAs(url, calculatedFilename);
  }
}
